export default __webpack_public_path__ + "images/941da4bc7f1d6f1cf2e92523de6814b3.svg";